import { lazy } from 'react';

/* istanbul ignore next */
export const Composer = lazy(() => import('./Composer'));
export const FreePhoto = lazy(() => import('./FreePhoto'));
export const MatchEvents = lazy(() => import('./MatchEvents'));
export const MatchSummary = lazy(() => import('./MatchSummary'));
export const Social = lazy(() => import('./Social'));
export const UefaEditorial = lazy(() => import('./UefaEditorial'));
export const Poll = lazy(() => import('./Poll'));
export const Card = lazy(() => import('./Card'));
export const VideoPost = lazy(() => import('./VideoPost'));
